import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";
import { getGenre } from "@/mocks/genres";

export default function ComicCard({ comic }: { comic: Comic }) {
  const genre = getGenre(comic.genre);
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title} - ${genre.name}题材韩漫封面`}
          title={`${comic.title} · ${genre.name}漫画`}
          loading="lazy"
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded bg-background-950/60 px-2 py-0.5 text-xs font-medium text-background-50 backdrop-blur-sm">
          {comic.status}
        </span>
        {comic.hot && (
          <span className="absolute right-2 top-2 flex h-6 items-center gap-0.5 rounded-full bg-primary-500 px-2 text-xs font-semibold text-background-50">
            <i className="ri-fire-fill text-[10px]" /> 热
          </span>
        )}
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
          {comic.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500">{comic.author}</p>
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-secondary-500" /> {comic.rating.toFixed(1)}
          </span>
          <span>{comic.chapters}话</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" /> {comic.views}万
          </span>
        </div>
      </div>
    </Link>
  );
}